export function ShipCard({ children }) {
  return (
    <div className="bg-white rounded-3xl shadow-sm border border-gray-200 p-6 sm:p-8 hover:shadow-md transition-shadow duration-200">
      {children}
    </div>
  );
}